import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const zuDe = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso || "";
};

// Akzeptiert TT.MM.JJJJ (auch T.M.JJJJ) und JJJJ-MM-TT; liefert ISO oder null
export const parseDatum = (txt) => {
  const s = String(txt || "").trim();
  let m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s);
  const iso = m ? `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}` : (/^\d{4}-\d{2}-\d{2}$/.test(s) ? s : null);
  if (!iso) return null;
  const [jahr, mon, tag] = iso.split("-").map(Number);
  const d = new Date(jahr, mon - 1, tag);
  if (d.getFullYear() !== jahr || d.getMonth() !== mon - 1 || d.getDate() !== tag) return null;
  return jahr > 1900 && jahr <= new Date().getFullYear() ? iso : null;
};

// Geburtsdatum als Texteingabe TT.MM.JJJJ – kein stilles Verwerfen unvollständiger Eingaben
export const GeburtsdatumInput = ({ value, onChange, testid = "input-geburtsdatum" }) => {
  const [txt, setTxt] = useState(typeof value === "string" ? zuDe(value) : "");
  useEffect(() => {
    // nur von außen kommende gültige Werte übernehmen, laufende Eingabe nicht überschreiben
    if (typeof value === "string" && value !== (parseDatum(txt) || "")) setTxt(zuDe(value));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const ungueltig = txt.trim() !== "" && !parseDatum(txt);
  return (
    <div>
      <Input
        value={txt}
        placeholder="TT.MM.JJJJ"
        inputMode="numeric"
        onChange={(e) => {
          setTxt(e.target.value);
          const iso = parseDatum(e.target.value);
          if (iso || e.target.value.trim() === "") onChange(iso || "");
          else onChange({ ungueltig: e.target.value });
        }}
        className={ungueltig ? "border-red-500" : ""}
        data-testid={testid}
      />
      {ungueltig && <p className="text-xs text-red-600 mt-1" data-testid={`${testid}-fehler`}>Bitte vollständig als TT.MM.JJJJ eingeben (z. B. 12.05.1965)</p>}
    </div>
  );
};

export const istUngueltig = (v) => v && typeof v === "object" && "ungueltig" in v;
